import { Component, Inject, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { environment } from 'src/environments/environment';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../filter/filter.model';
import { MatTableDataSource } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';
import { ManagerService } from 'src/app/services/manager/manager.service';
import { MoreCourseInfoComponent } from '../courses/more-course-info/more-course-info.component';
import { ViewExamsheetComponent } from '../courses/view-examsheet/view-examsheet.component';
import { AssignCourseEmployeeWiseComponent } from '../courses/assign-course-employee-wise/assign-course-employee-wise.component';
import { ConfirmationModalComponent } from '../dialog-modal/confirmation-modal/confirmation-modal.component';
import { DeleteItemComponent } from '../delete-item/delete-item.component';
import { MessageComponent } from '../employees/message/message.component';
import { JobService } from 'src/app/services/job/job.service';
import { SettingsComponent } from '../recruitment/time-clock-card/settings/settings.component';
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { AddCategoryComponent } from '../company-settings/add-category/add-category.component';
import { TimeSetting } from 'src/app/model/settings';
import { MY_OWL_FORMATS } from 'src/app/model/owl_date';
import { PositiveNumber } from 'src/app/model/positive_number';
import { RulesService } from 'src/app/services/rules/rules.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


interface OvertimeWeekDays {
  daily_overtime: string[];
  partial_day_overtime: string[];
  premium_time: string[];
  night_premium: [];
  consecutive_days_overtime: string[];
}
enum UserType {
  company = "company",
  recruiter = "recruiter"
}
enum WageType {
  defaultCompany = "def_com",
  defaultEmployee = "def_emp",
  specificCompany = "spe_com",
  specificEmployee = "spe_emp"
}

@Component({
  selector: 'app-view-company',
  templateUrl: './view-company.component.html',
  styleUrls: ['./view-company.component.scss']
})
export class ViewCompanyComponent {
  mainPortalUrl: SafeResourceUrl | undefined;
  public rawUrl: string = environment.mainPortalUrl + 'dashboard/dashboard2';
  public breakType: string = "disable_breaks"
  public limitationArr = [
    { key: "custom_limit_by_day_sun", "fr": "", "to": "", "sun": "1", val: "S", selected: false },
    { key: "custom_limit_by_day_mon", "fr": "", "to": "", "mon": "1", val: "M", selected: false },
    { key: "custom_limit_by_day_tues", "fr": "", "to": "", "tues": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_wed", "fr": "", "to": "", "wed": "1", val: "W", selected: false },
    { key: "custom_limit_by_day_thur", "fr": "", "to": "", "thur": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_fri", "fr": "", "to": "", "fri": "1", val: "F", selected: false },
    { key: "custom_limit_by_day_sat", "fr": "", "to": "", "sat": "1", val: "S", selected: false },
  ]
  public workdays = [
    { label: "S", value: "sun", selected: false, hours: "8" },
    { label: "M", value: "mon", selected: false, hours: "8" },
    { label: "T", value: "tues", selected: false, hours: "8" },
    { label: "W", value: "wed", selected: false, hours: "8" },
    { label: "T", value: "thur", selected: false, hours: "8" },
    { label: "F", value: "fri", selected: false, hours: "8" },
    { label: "S", value: "sat", selected: false, hours: "8" },
  ];
  public overtimeWeekDays: OvertimeWeekDays = {
    daily_overtime: [],
    premium_time: [],
    night_premium: [],
    partial_day_overtime: [],
    consecutive_days_overtime: [],
  }
  public remDays = [
    { label: "S", value: "sun", selected: false, },
    { label: "M", value: "mon", selected: false, },
    { label: "T", value: "tues", selected: false, },
    { label: "W", value: "wed", selected: false, },
    { label: "T", value: "thur", selected: false, },
    { label: "F", value: "fri", selected: false, },
    { label: "S", value: "sat", selected: false, },
  ];
  public automaticArr: any[] = [
    { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "1" }
  ];
  public generalObj = {
    "default_work_hour": { "fr": "10:00", "to": "10:00" },
    daily_limit_exceed: { "value": "5", selected: false, "hmd": "1", "af_bf": "0", },
    auto_clock_out_hour: { "hmd": "1", "af_bf": "0", "value": "10", selected: false },
    show_pay_rates: { "yes_no": "1", selected: false },
    timesheet_rounding: { yes_no: "1", value: "2", selected: false },
    payroll_cycle: { hmd: "3", value: "" },
    timesheet_approval: { "yes_no": "1", selected: false },
    "timesheet_review_user": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "Please review your work hours in the timesheet!" },
    "timesheet_review_admin": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "It is time to review your employees' timesheets" },
    // Reminders 
    "reminder_active_on": this.getRemArray(this.remDays),
    "employee_clockin_at": { "value": "10", selected: false },
    "employee_clockout_at": { "value": "20", selected: false },
    // Notification object
    "add_new_shift": { "mobile": false, "push": "", "email": false },
    "edit_shift": { "mobile": "1", "push": "", "email": "" },
    "exceed_work_hour": { "mobile": "1", "push": "", "email": "" },
    "auto_clock_out": { "mobile": "1", "push": "", "email": "" },
    "request_pending_approval": { "mobile": "1", "push": "", "email": "", "value": "" },
    "submitted_timesheet": { "mobile": "1", "push": "", "email": "" },
    "app_disapp_job": { "mobile": "1", "push": "", "email": "" },
    //Limitation object
    "clock_in_limitation": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    "auto_clockout_time": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    // geolocation
    "geolocation": { track: '1' },
    //breaks
    "manual_breaks": { "yes_no": "0", selected: false },
    "automatic_breaks": this.automaticArr,
    "disable_breaks": { "yes_no": "0", selected: false },
    //overtime
    "weekly_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "daily_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    // "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    // "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "pay_period_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    //limitation custom limit by days
    "custom_limit_by_day_sun": { "fr": "", "to": "", "sun": "1", val: "S", selected: false },
    "custom_limit_by_day_mon": { "fr": "", "to": "", "mon": "1", val: "M", selected: false },
    "custom_limit_by_day_tues": { "fr": "", "to": "", "tues": "1", val: "T", selected: false },
    "custom_limit_by_day_wed": { "fr": "", "to": "", "wed": "1", val: "W", selected: false },
    "custom_limit_by_day_thur": { "fr": "", "to": "", "thur": "1", val: "T", selected: false },
    "custom_limit_by_day_fri": { "fr": "", "to": "", "fri": "1", val: "F", selected: false },
    "custom_limit_by_day_sat": { "fr": "", "to": "", "sat": "1", val: "S", selected: false },
    "premium_time": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "night_premium": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10","fr": "21","to":"7" ,"s_m": 1, "s_mv": "2.6" },
    "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6","fr": "8","to":"11" },
    "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6","st_on":"7" },
  }


  @ViewChild('activityLog') activityLog!: ElementRef;

  dateFormat = MY_OWL_FORMATS;
  public settingsArr: any[] = [
    { name: "Visa", icon: "fa-cog", id: 0, u_typ: ['company', 'recruiter'] },
    // { name: "Pay Rates", icon: "fa-cog", id: 1, u_typ: ['company', 'recruiter'] },
    { name: "Invoicing Rates for Company", icon: "fa-cog", id: 2, u_typ: ['recruiter'] },
    { name: "Employee Pay Rates", icon: "fa-cog", id: 3, u_typ: ['company', 'recruiter'] },
    { name: "Premium Time", icon: "fa-cog", id: 4, u_typ: ['company', 'recruiter'] },
    // {name:"Team Member",icon:"fa-cog"}, 
    // {name:"Notifications",icon:"fa-cog"}, 
  ]

  public visaDateArr: any[] = [
    { d_h: "", s_dt: "", e_dt: "" }
  ]
  public condIds1: any = '';
  public condIds0: any = '';
  public ids1: any = '';
  public ids0: any = '';
  public selectedSetting: any;
  public visaForm!: FormGroup;
  public displayedColumns: string[] = ['title', 'created_at', 'action'];
  public dataSource = new MatTableDataSource([]);


  public searchInput: string = '';
  private previousInputValue: string = '';
  public youngVisaForm!: FormGroup;
  public userType!: string;
  public wageType!: string;

  public weekdaysArr: any[] = [
    { name: "Sunday", abb: "S", val: "sun" },
    { name: "Monday", abb: "M", val: "mon" },
    { name: "Tuesday", abb: "T", val: "tue" },
    { name: "Wednesday", abb: "W", val: "wed" },
    { name: "Thursday", abb: "T", val: "thur" },
    { name: "Friday", abb: "F", val: "fri" },
    { name: "Saturday", abb: "S", val: "sat" },
  ]
  public multiplier: string = 'multiply';


  selectedItemId: any;
  public empStatistics
  public boxArr: any[] = [
    { content_type: 'courses', text: "Total Courses", cont_img: "assets/images/courses/total_courses.png", progress_bar_color: "green-progress", filterBy: "t_c" },
    { content_type: 'course started', text: "Total Courses Started", cont_img: "assets/images/courses/total_course_started.png", progress_bar_color: "orange-progress", filterBy: "t_p" },
    { content_type: 'exam attended', text: "Total Exam Attended", cont_img: "assets/images/courses/total_exam_attended.png", progress_bar_color: "red-progress", filterBy: "tnsc" },
    { content_type: 'course passed', text: "Total Course Passed ", cont_img: "assets/images/courses/total_passed.png", progress_bar_color: "sky-progress", filterBy: "ex_at" },
    { content_type: 'course failed', text: "Total Course Failed", cont_img: "assets/images/courses/total_course_failed.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
    { content_type: 'informational course', text: "Total Informational Course", cont_img: "assets/images/courses/total_informational_course.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
    { content_type: 'exam course', text: "Total Course With Exam", cont_img: "assets/images/courses/total_course_with_exam.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
  ]
  public selectedFilter!: string;
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public activityArr: any[] = [];
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "employee_first_name", type: 'text' },
    { key_name: "Last Name", key_val: "employee_last_name", type: 'text' },
    { key_name: "Email", key_val: "employee_email", type: 'text' },
    { key_name: "Department", key_val: "department_name", type: 'select' },
    { key_name: "Training Date", key_val: "deadline_date", type: 'date' },
    { key_name: "Deadline Date", key_val: "training_date", type: 'date' },
  ]
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public imageURL: any = GlobalService.imageURL;
  public displayedColumns2: string[] = ['category', 'sub_category', 'action'];
  public dataSource2 = new MatTableDataSource([]);
  public count!: any;
  public empData;
  public courseStatistics: any;
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  isFavourite = false;
  title: string = '';
  public sideMenu: any[] = [
    { name: "Payroll", id: 3, icon: "work" },
    { name: "Settings", id: 6, icon: "settings_applications" },
  ]
  public selectedSideMenu!: string;
  public arr: any[] = [
    // { name: "Current Shift", id: "current_shift", cl: "current", color: "#fd9332", icon: "today", },
    // { name: "Upcoming Shift", id: "upcoming_shift", cl: "upcoming", color: "rgba(4, 195, 172, 1)", icon: "event" },
    // { name: "Past Shift", id: "past_shift", cl: "past", color: "rgba(134, 103, 255, 1)", icon: "assignment_return" },
    // { name: "Approved Roles", id: "approved_roles", cl: "approved", color: "rgba(57, 163, 7, 1)", icon: "supervisor_account" },
    // // { name: "Manager", id: "manager", cl: "manager", color: "rgba(254, 76, 138, 1)", icon: "assets/images/icons/manager.svg" },/
    // { name: "Message", id: "message", cl: "message", color: "var(--primary-color)", icon: "message" },
  ]
  public objData = {
    training: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    current_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    upcoming_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    past_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    }
  };

  public timeSetting: TimeSetting = {
    premiumTime: {
      selectedDays: [],
      default: false,
      custom: '',
      selectedMonth: []
    },
    weeklyOt: {
      isEnabled: "",
      startsAfter: "",
      wageType: "multiply",
      wages: "",
    },
    nightPremium: {
      isEnabled: "",
      wageType: "multiply",
      wages: "",
      betweenStart: "",
      betweenEnd: ""
    },
    daily: {
      isEnabled: "",
      selectedDays: [],
      startsAfter: "",
      wageType: "multiply",
      wages: "",
      selectedMonth: []
    },
    partial: {
      isEnabled: "",
      selectedDays: [],
      startsAfter: "",
      wageType: "multiply",
      wages: "",
    },
    payPeriod: {
      isEnabled: "",
      startsAfter: "",
      wageType: "multiply",
      wages: "",
      selectedMonth: []
    }
  }

  public displayedColClock: string[] = ['title', 'department', 'start_date', 'end_date', 'action'];

  public displayedColPast: string[] = ['company_name', 'title', 'category', 'date', 'time', 'wages'];
  public displayedColUpc: string[] = ['company_name', 'company_add', 'title', 'date', 'time', 'wages'];
  public displayedColCurrent: string[] = ['company_name', 'title', 'department', 'date', 'time', 'wages'];

  public tempColumn: any = [];

  public dataSourceClock = new MatTableDataSource();
  public dataSourcePast = new MatTableDataSource();
  public dataSourceUpc = new MatTableDataSource();

  public dataSourceCurrent = new MatTableDataSource();

  public co_i!: any
  public showModal: boolean = false;
  public employeeId!: any;

  public startDate: any;
  public endDate: any;
  public dateForm!: FormGroup;
  public countPagination!: any

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private managerService: ManagerService,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<ViewCompanyComponent>,
    private jobService: JobService,
    private recruterService: RecruiterService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private commonservice: CommonService,
    private recruiterService: RecruiterService,
    private rulesService: RulesService,
    private cookieService: CookieService,
    private sanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    if (this.dialogData?.mType == "dashboard") {
      this.mainPortalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.rawUrl);
      this.getCompanyToken()
      return
    }


    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    // this.userType = userInfo.u_typ == 0 ? 'company' : 'recruiter';
    this.userType = userInfo.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');
    this.co_i = userInfo.company_id;


    this.tempColumn = this.displayedColPast;
    this.employeeId = this.dialogData.employee_id;



    this.selectedSideMenu = '3';
    this.title = "Payroll"
    this.getList()
  }
  onBoxSelected(item: any) { }

  doFilter = (event: any) => {
    let newVal = event.target?.value
    this.dataSource.filter = newVal.trim().toLocaleLowerCase();
  }

  getList() {

    //spe_emp here means specific employee hence pass the employee id also.
    let objReq = {
      "w_t": "spe_com",
      "jc_id": "",
      "em_i": "",
      "co_i": this.dialogData.co_i,
    }
    this.dataSource = new MatTableDataSource([])
    this.recruiterService.getJobCategories(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.msg);
        }
      },
      error: (error: any) => {
        this.commonservice.handleError(error);
      }
    })
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onViewExamSheet(element: any) {
    const dialogRef = this.dialog.open(ViewExamsheetComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '70%', minWidth: '280px', maxWidth: "800px" }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onMoreInfo(element) {
    const dialogRef = this.dialog.open(MoreCourseInfoComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '55%', minWidth: '300px', maxWidth: "800px", height: '98%', maxHeight: '600px' }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onCertificateDownload(element: any) {
    this.appService.downloadFile(element.c_img, 'certificate.png')
  }
  view(id, type?: string) {
    this.isSpinnerLoading = true
    let data = {
      co_i: this.co_i,
      employee_id: id,
      sh: type ? this.objData[type].sh : "",
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    if (type) {
      this.objData[type].previousInputValue = this.objData[type].sh;
    }
    this.managerService.viewEmployee(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.isSpinnerLoading = false;
        this.empData = response.data.employee_info
        this.courseStatistics = response.data.assign_course_statistics
        this.dataSource = new MatTableDataSource(response.data.course);
        this.onEmployeeCourseStats()
        this.count = response.data.count

        this.isFavourite = this.empData.u_type == 0 ? false : true;
      }
    })
  }
  changeCertifcateAccess(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = this.dialogData.employee_id
    dataObj["is_build"] = item["is_build"]
    // dataObj["m_c_g"] = !value["checked"]
    dataObj["m_c_g"] = value["checked"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = item["is_pr"]
    dataObj["t"] = item["t"]
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'certificate access')
  }
  changeCoursePractical(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = this.dialogData.employee_id
    dataObj["is_build"] = item["is_build"]
    dataObj["m_c_g"] = item["m_c_g"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = value["checked"]
    dataObj["t"] = item["t"]
    // doing this so value does not get checked untill it is confirmed using confirmation dialog boxes.
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'course practical')
  }
  confirmationAlert(dataObj: any, content_type: any) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { dataObj, content_type: content_type }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.view(this.dialogData.employee_id)
        }
      }
      if (result == undefined) {
        // if(content_type=='course practical'){
        //   return dataObj
        // }
      }
    });
  }
  onEmployeeCourseStats() {
    let value: any;
    this.boxArr.map((item: any) => {
      let content_type = item["content_type"];
      if (content_type == 'courses') {
        item["value"] = this.courseStatistics.total_course
      }
      if (content_type == 'course started') {
        item["value"] = this.courseStatistics.total_started_course
      }
      if (content_type == 'exam attended') {
        item["value"] = this.courseStatistics.total_attend_exam
      }
      if (content_type == 'course passed') {
        item["value"] = this.courseStatistics.total_pass_exam
      }
      if (content_type == 'course failed') {
        item["value"] = this.courseStatistics.total_fail_exam
      }
      if (content_type == 'informational course') {
        item["value"] = this.courseStatistics.total_informational_course
      }
      if (content_type == 'exam course') {
        item["value"] = this.courseStatistics.total_non_informational_course
      }
    })
  }

  onAssignCourse() {
    let obj = {
      id: this.dialogData.employee_id
    }
    const dialogRef = this.dialog.open(AssignCourseEmployeeWiseComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      panelClass: "hire", autoFocus: false,
      height: '100%',
      width: '90%',
      maxHeight: '746px',
      maxWidth: '1182px',
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.view(this.dialogData.employee_id)
      }
    });
  }
  onSideMenuChange(item: any) {
    this.clearSearchBox();
    this.title = item["name"];
    this.selectedItemId = "";
    this.selectedSideMenu = item["id"];
    if (this.selectedSideMenu == '6') {
      // this.onOpenSetting()
      this.getSettings()
    }
    if (this.selectedSideMenu == '0') {
      this.getActivity()
    }
    if (this.selectedSideMenu == '3') {
      this.getCompanyDate()
    }
    setTimeout(() => {
      this.onScroll()
    }, 100)
  }

  getCompanyDate() {
    this.getList()
  }

  onScroll() {
    if (this.activityLog) {
      this.activityLog.nativeElement.parentElement.parentElement.scrollTop = this.activityLog.nativeElement.parentElement.parentElement.scrollHeight;
    }
  }


  // mat-mdc-dialog-surface

  getActivity() {

    let obj = {
      // j_id: this.dialogData.employee_id,
      st_dt: this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      ed_dt: this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
    }

    this.isSpinnerLoading = true;
    this.jobService.getShiftActivity(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.activityArr = success.msg;

        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false

      }
    })

  }

  onOpenSetting() {
    const dialogRef = this.dialog.open(SettingsComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      minWidth: '300px',
      width: '95%',
      height: '90%',
      maxWidth: '100%',
      data: { r_type: 2, u_t: 3, u_id: [this.dialogData.employee_id], em_i: this.dialogData.employee_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
      this.selectedSideMenu = '4';
      this.title = this.sideMenu[4]["name"];
    });
  }
  clearSearchBox(): void {
    this.objData.current_shift.sh = ''
    this.objData.upcoming_shift.sh = ''
    this.objData.training.sh = ''
    this.objData.past_shift.sh = ''
  }
  onMenuBox(item: any) {
    this.clearSearchBox();
    if (item.id == "upcoming_shift") {
      this.displayedColPast = ['company_name', 'company_add', 'title', 'category', 'date', 'time', 'wages'];;
    } else {
      this.displayedColPast = this.tempColumn;
    }
    this.title = item.name;
    // this.selectedItemId = value;

    this.config.currentPage = 1
    this.config.itemsPerPage = this.pageSizeOptions[0]
    this.selectedSideMenu = item.id;
    if (item.id == "message") { //open message model
      this.onAddMessage()
    } else {
      this.getEmp()
    }

    setTimeout(() => {
      this.onScroll()
    }, 100)
  }
  onAddMessage() {
    let dataObj = {
      employee_id: this.dialogData.employee_id
    }
    const dialogRef = this.dialog.open(MessageComponent, {
      data: dataObj, width: '90%', maxWidth: "400px", height: "95%", maxHeight: '470px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.view(this.dialogData.employee_id)
        }
      }
      if (result == undefined) {
        // if(content_type=='course practical'){
        //   return dataObj
        // }
      }
    });
  }
  getEmp(user_type?: string) {

    this.isSpinnerLoading = true;
    let obj: any = {
      type: "", // 1=clockin data, 2= not clockinn data,  3 = upcooming job, 4 = current job,  5 = past working 6=approved_roles
      em_i: this.dialogData.employee_id
    }
    const searchField = user_type ? this.objData[user_type].sh : '';
    if (this.selectedSideMenu == 'current_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.sh = searchField,
        obj.r_p = this.config.itemsPerPage,
        obj.type = "4"
    }
    else if (this.selectedSideMenu == 'upcoming_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.sh = searchField,
        obj.r_p = this.config.itemsPerPage,
        obj.type = "3"
    }
    else if (this.selectedSideMenu == 'past_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.r_p = this.config.itemsPerPage,
        obj.sh = searchField,
        obj.type = "5"
    }
    else if (this.selectedSideMenu == 'approved_roles') {
      obj.type = "6"
    }
    else {

    }
    if (user_type) {
      this.objData[user_type].previousInputValue = this.objData[user_type].sh;
    }
    this.jobService.getEmpDetail(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.countPagination = success.count;
          if (this.selectedSideMenu == 'current_shift') {
            this.dataSourceCurrent = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'upcoming_shift') {
            this.dataSourceUpc = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'past_shift') {
            this.dataSourcePast = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'approved_roles') { }
          else { }
        }
      },
      error: (error: any) => {
        this.dataSourceCurrent.data = []
        this.dataSourceUpc.data = []
        this.dataSourcePast.data = []
        this.isSpinnerLoading = false

      }
    })

  }





  toggleFavourite() {
    this.isFavourite = !this.isFavourite;


    // this.isSpinnerLoading = true
    let data = {
      "em_i": this.dialogData.employee_id,
      "u_type": this.isFavourite == true ? 1 : 0
    }
    this.recruterService.addToFavorite(data).subscribe((response: any) => {
      if (response.status == 200) {

      }
    })
  }

  openTypeEditModel(item) {
    // status is approved still user pressess accept button then no need to change the api 
    let data = {
      "em_i": this.dialogData.employee_id,
      "salaried": item === 1 ? 0 : 1,
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { content_type: 'employee type', data_type: 'Change employe type', dataObj: data, item_type: "emp_type" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.dialogData) {
        }
      }
    });
  }

  saveChanges(type: any) {

    let data = {
      "em_i": this.dialogData.employee_id,
      "salaried": type === 1 ? 0 : 1,
    }
    this.recruterService.onChangeEmpSalried(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.empData.salaried = data.salaried;
        this.showModal = false;
      }
    })
  }


  closeModal() {
    this.showModal = false;
  }

  // openTypeEditModel() {
  //   this.showModal = true;

  // }

  onSaveWages(item) {
    if (item.wages == "" || item.wages == null || item.wages == undefined) {
      return item["error"] = "This is required";
    }
    else if (item.wages < 0) {
      return item["error"] = "Please add non-negative value";
    }
    else {
      item["error"] = "";
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: { content_type: 'wages' }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result["confirm_yes"] == true) {
            let objReq = {
              "j_sc_id": item.id,
              "w_t": "spe_com",
              "wages": item.wages,
              "em_i": this.employeeId
            }
            this.recruiterService.saveWages(objReq).subscribe({
              next: (success: any) => {
                // this.spinner.hide();
                if (success.status == 200) {
                  this.appService.showToastMessage('success', success.msg)
                }
              },
              error: (error: any) => {
                this.commonservice.handleError(error)
              }
            })
          }
        }
      });
    }
    return;
  }

  onAddEdit(type, item) {
    // same menu opens from different places one is from view employee page/ main company setting page while adding new company
    let objData = {
      isEmployeeSetting: true,
      wages_type: "spe_com",
      co_i: this.dialogData.co_i,
      type: "specCom",
    }
    if (type == 'edit') {
      objData["category_data"] = item
    }
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      data: objData,
      width: '70%', minWidth: '300px', maxWidth: '750px', height: '98%',
      maxHeight: '680px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.getList()
        }
      }
    });
  }

  onSelectDay(setting, item: any) {
    const days = this.timeSetting[setting]['selectedMonth'];
    const index = days.indexOf(item.val);
    if (index > -1) {
      days.splice(index, 1);
    } else {
      days.push(item.val);
    }
  }
  checkSelectedDay(settingType: string, value) {
    if (!this.timeSetting[settingType].selectedMonth) {
      this.timeSetting[settingType].selectedMonth = [];
    }
    return this.timeSetting[settingType].selectedMonth.includes(value);
  }

  get visaDates() {
    return this.visaForm.get('dates') as FormArray;
  }
  get youngVisaDates() {
    return this.youngVisaForm.get('dates') as FormArray;
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.youngVisaForm, controlName, validationType);
  }
  addVisaDates() {
    const datesForm = this.fb.group({
      st_dt: ['', Validators.required],
      ed_dt: ['', Validators.required],
      permitted_hour: ["", [Validators.required, PositiveNumber]],
    });
    this.visaDates.push(datesForm);
  }
  removeVisaDates(index: number) {
    this.visaDates.removeAt(index)
  }
  addYoungVisaDates() {
    const datesForm = this.fb.group({
      st_dt: ['', Validators.required],
      ed_dt: ['', Validators.required],
      permitted_hour: ["", [Validators.required, PositiveNumber]],
      st_ti: ["", Validators.required],
      ed_ti: ["", Validators.required]
    });
    this.youngVisaDates.push(datesForm);
  }
  removeDates(index: number) {
    this.youngVisaDates.removeAt(index);
  }
  onSelectedSettings(item) {
    this.selectedSetting = item;

    if (this.selectedSetting.id == 2) {
      this.wageType = WageType.defaultCompany;
    }
    else {
      this.wageType = WageType.defaultEmployee;
    };

    if (item.name == "Visa") {
      this.getVisaAPI()
    } else {
      this.getCategoryList();
    }

  }
  onDeleteItem(item) {
    this.visaDateArr.splice(item, 1)
  }
  onAddNewDate() {
    this.visaDateArr.push({ d_h: "", s_dt: "", e_dt: "" })
  }
  onSubmitYoungVisa() {

    if (this.visaForm.invalid) {
      this.visaForm.markAllAsTouched()
    }
    if (this.youngVisaForm.invalid) {
      this.youngVisaForm.markAllAsTouched()
    }
    else {
      let objReq = this.youngVisaForm.value;
      let newArr = [...objReq.dates];
      newArr.map((item) => {
        item["st_dt"] = this.datePipe.transform(item["st_dt"], "yyyy-MM-dd");
        item["ed_dt"] = this.datePipe.transform(item["ed_dt"], "yyyy-MM-dd");
        item["id"] = this.condIds0;
      })
      objReq.dates = newArr;


      let newVisaDateArr = this.visaForm.get('dates')?.value;
      newVisaDateArr.map((item) => {
        item["st_dt"] = this.datePipe.transform(item["st_dt"], "yyyy-MM-dd");
        item["ed_dt"] = this.datePipe.transform(item["ed_dt"], "yyyy-MM-dd");
        item["id"] = this.condIds1;
        item["st_ti"] = "";
        item["ed_ti"] = "";
      })
      let sendReq = {};
      sendReq["v_d"] = [
        {
          "id": this.ids1,
          "d_h": this.visaForm.get('d_h')?.value,
          "age": "",
          "u_t": "1",//for the manage legal compliance
          "cond": newVisaDateArr
        },
        {
          "id": this.ids0,
          "d_h": this.youngVisaForm.get('d_h')?.value,
          "u_t": "0",//for young worker's rules pass 1
          "age": this.youngVisaForm.get('age')?.value,
          "cond": newArr,
        }
      ]
      this.callVisaAPI(sendReq)
    }
  }
  onSubmitVisa() {
    if (this.visaForm.invalid) {
      this.visaForm.markAllAsTouched()
    }
    else {
    }
  }

  callVisaAPI(data) {
    this.recruiterService.addVisaRule(data).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
        }
      },
      error: (error: any) => {
        this.commonservice.handleError(error)
      }
    })
  }

  getVisaAPI() {

    var data = {};

    this.recruiterService.getVisaRule(data).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          // this.appService.showToastMessage('success', success.msg)
          success.msg.forEach(item => {

            if (item.u_t === 1) {
              this.ids1 = item.id;

            } else if (item.u_t === 0) {
              this.ids0 = item.id;
            }

            if (item.cond.length > 0) {
              item.cond.forEach(condItem => {
                if (condItem.u_t === 1) {
                  this.condIds1 = condItem.id;
                } else if (condItem.u_t === 0) {
                  this.condIds0 = condItem.id;
                }
              });
            }
          });
        }
      },
      error: (error: any) => {
        this.commonservice.handleError(error)
      }
    })
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getCategoryList();
  }



  getCategoryList() {
    let objReq = {
      "jc_id": "",
      "em_i": "",
      "co_i": "",
      sh: this.searchInput.trim(),
      "w_t": this.wageType
    }
    this.dataSource = new MatTableDataSource()
    this.recruiterService.getJobCategories(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.count = success.count
          this.dataSource = new MatTableDataSource(success.msg)
          this.previousInputValue = this.searchInput;
        }
      },
      error: (error: any) => {
        this.dataSource.data = []
        this.commonservice.handleError(error)
      }
    })
  }
  onAddEditCat(type, item) {
    let objData = {}
    objData["wages_type"] = this.wageType


    if (type == 'edit') {
      objData["category_data"] = item
    }
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: '70%', minWidth: '300px', maxWidth: '750px', height: '98%',
      maxHeight: '680px', enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      // minHeight:'200px'
      data: objData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.getCategoryList()
        }
      }
    });
  }


  getRemArray(array: any[]) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        transformedObject[item.value] = "1";
      }
      else {
        transformedObject[item.value] = "0";
      }
    });
    return transformedObject;
  }

  onAddDaysOvertime(type: any, val: any) {
    let newArr = this.overtimeWeekDays[type];


    if (newArr.includes(val.value)) {
      newArr.splice(newArr.indexOf(val.value), 1);
    }
    else {
      newArr.push(val.value);
    }
    if (this.generalObj[type].hasOwnProperty(val.value)) {

      delete this.generalObj[type][val.value];
    }
    else {
      const obj = {};
      obj[val.value] = "1";
      this.generalObj[type] = Object.assign(this.generalObj[type], obj);
    }
  }

  getSelectedDays(type: any, val: any) {
    if (this.overtimeWeekDays[type].includes(val)) {
      return true;
    }
    return false;
  }

  onSubmitRules() {
    this.callApi(this.generalObj)
  }
  callApi(obj) {
    obj["r_type"] = "2";
    obj["u_t"] = "1";
    obj["u_id"] = [this.dialogData.co_i];

    obj["reminder_active_on"] = this.getRemArray(this.remDays)
    obj["work_days_length_limit"] = this.transformedArray(this.workdays, 'general')

    for (let i = 0; i < this.limitationArr.length; i++) {
      if (this.limitationArr[i]["selected"] == true) {
        const { key, val, ...remainingProperties } = this.limitationArr[i];   // Remove unwanted keys from the original object
        const limitObj = { [key]: remainingProperties };        // Create a new object with the remaining properties
        Object.assign(obj, limitObj);
      }
    }
    if (this.breakType == "disable_breaks") {
      obj["disable_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["manual_breaks"]
    }
    else if (this.breakType == "manual_breaks") {
      obj["manual_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["disable_breaks"]
    }
    else {
      obj["automatic_breaks"] = this.automaticArr
      delete obj["manual_breaks"]
      delete obj["disable_breaks"]
    }

    this.rulesService.submitRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close()
        }
      },
      error: (error: any) => {
        this.commonservice.handleError(error);
      }
    })
  }

  transformedArray(array: any[], type: string) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        if ((item.hours == "" || item.hours == null)) { item.hours = "8" }
        transformedObject[item.value] = item.hours;
      }
      else {
        transformedObject[item.value] = "";
      }
      // newWorkDaysArr.push(transformedObject)// Assign "10" to each key
    });
    return transformedObject;
  }

  getSettings() {
    const obj = {
      "r_type": "2",
      // "co_i" : this.dialogData.co_i,
      "em_i": this.dialogData.co_i,
      "u_t": "1",
    }

    this.rulesService.getRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          let data = success.msg;
          for (let [key, val] of Object.entries(data)) {
            if (key in this.generalObj) {
              this.generalObj[key] = val;
              if (key == "reminder_active_on") {
                for (let i = 0; i < this.remDays.length; i++) {
                  if (this.generalObj[key][this.remDays[i].value] == "1") {
                    this.remDays[i]["selected"] = true
                  }
                }
              }
              for (let i = 0; i < this.limitationArr.length; i++) {
                const keyValue = this.limitationArr[i].key;
                if (this.generalObj.hasOwnProperty(keyValue)) {
                  this.limitationArr[i]["fr"] = this.generalObj[keyValue]["fr"];
                  this.limitationArr[i]["to"] = this.generalObj[keyValue]["to"];
                  this.limitationArr[i]["selected"] = this.generalObj[keyValue]["selected"]
                }
              }
            }
            this.automaticArr = [];
            if (data.hasOwnProperty('work_days_length_limit')) {
              this.setSettings(data["work_days_length_limit"])
            }
            if (data.hasOwnProperty('disable_breaks')) { this.breakType = "disable_breaks" }
            if (data.hasOwnProperty('manual_breaks')) { this.breakType = "manual_breaks" }
            if (data.hasOwnProperty('automatic_breaks')) {
              this.breakType = "automatic_breaks"
              this.automaticArr = data["automatic_breaks"]
            }
            //daily,partial and consecutive overtimes are selected then below function is logic to set the selected week days



          }

          this.setSelectedWorkdays(data, 'daily_overtime')
          this.setSelectedWorkdays(data, 'partial_day_overtime')
          this.setSelectedWorkdays(data, 'premium_time')
          this.setSelectedWorkdays(data, 'consecutive_days_overtime')
        }

        // this.dialogRef.close()
      },
      error: (error: any) => {
        //this.isSpinnerLoading = false
        this.commonservice.handleError(error);
      }
    })
  }

  setSelectedWorkdays(data, node_name) {
    const newArr = ['sun', 'mon', 'tues', 'wed', 'thur', 'fri', 'sat']
    if (data.hasOwnProperty(node_name)) {
      for (let key of Object.keys(data[node_name])) {
        if (newArr.includes(key)) {
          this.overtimeWeekDays[node_name].push(key)
        }
      }
    }
  }

  setSettings(obj) {
    this.workdays = this.workdays.map(day => {
      if (obj.hasOwnProperty(day.value)) {
        const hours = obj[day.value];
        return {
          ...day,
          selected: hours !== "" && hours !== null,
          hours: hours !== "" ? String(hours) : day.hours
        };
      }
      return day;
    });
  }

  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 1;
      this.getCategoryList()
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 1;
      this.getCategoryList()
    }
  }

  getCompanyToken() {
    let obj = {
      co_i: this.dialogData.co_i
    }
    this.recruiterService.getClientCompanyDetails(obj).subscribe({
      next: (success: any) => {
        let newCompanyData = success.data;
        newCompanyData["group_type"] = 'company'
        var newCompanyToken = success.token;

        var recCompanyData = this.appService.getData('training-portal.userInfo')
        var recCompanyToken = this.appService.getData('training-portal.authToken')
        this.cookieService.set(this.appService.getEncryptedText('training-portal.authToken'), success.token, undefined, '/', undefined, true, 'Strict')

        this.appService.storeSessionData('training-portal.userInfo', recCompanyData)
        this.appService.storeSessionData('training-portal.authToken', recCompanyToken)

        this.appService.storeData('training-portal.userInfo', JSON.stringify(newCompanyData))
        this.appService.storeData('training-portal.authToken', newCompanyToken)

        this.appService.storeSessionData('isViewCompany', 'true')
      },
      error: (error: any) => {
        this.commonservice.handleError(error);
      },
    }
    );
  }
  onCancel() {

    var recCompanyData = this.appService.getSessionData('training-portal.userInfo')
    var recCompanyToken = this.appService.getSessionData('training-portal.authToken')

    this.appService.storeData('training-portal.userInfo', recCompanyData)
    this.appService.storeData('training-portal.authToken', recCompanyToken)

    this.appService.removeSessionData('isViewCompany')
    this.appService.removeSessionData('training-portal.userInfo')
    this.appService.removeSessionData('training-portal.authToken')

    this.cookieService.set(this.appService.getEncryptedText('training-portal.authToken'), recCompanyToken, undefined, '/', undefined, true, 'Strict')

    this.dialogRef.close()
  }

  ngOnDestroy(): void {
    if (this.dialogData == "dashboard") {
      //Called once, before the instance is destroyed.
      //Add 'implements OnDestroy' to the class.
      if (this.appService.getSessionData('isViewCompany')) {
        this.appService.removeSessionData('isViewCompany')
      }
    }
  }
}



